import { IClient } from 'interfaces/IOrder'

export const getNameClient = (client_data: IClient): string => {
  if (client_data?.client_type === 'PF') {
    return client_data?.client_name
  }

  return client_data?.client_trade || client_data?.client_name
}
